import React, { useEffect } from "react";
import Button from "../../../components/Button/Button";
import { FaTimes, FaSave } from "react-icons/fa";

const SlideOver = ({ open, onClose, title, children }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[9999] flex"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div className="absolute inset-0 bg-black/50" />
      <div
        className="relative ml-auto h-full w-full max-w-xl bg-white dark:bg-slate-900 shadow-xl
                   border-l border-gray-200 dark:border-slate-700 p-5 sm:p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            {title}
          </h3>
          <button
            onClick={onClose}
            aria-label="Fermer"
            className="h-8 w-8 rounded-full bg-black/10 dark:bg-white/10 flex items-center justify-center"
          >
            ×
          </button>
        </div>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};

const CreateInvitedClubModal = ({ open, onClose, onSubmit, userId }) => {
  const [form, setForm] = React.useState({
    nom_club: "",
    mail_club: "",
    tel_club: "",
  });

  const submit = (e) => {
  e.preventDefault();
  if (!form.nom_club.trim()) return;

  const data = { ...form, user_id: userId };
  console.log("[CreateInvitedClubModal] submit → data", data);
  onSubmit(data);
};

  useEffect(() => {
    if (!open) setForm({ nom_club: "", mail_club: "", tel_club: "" });
  }, [open]);

  return (
    <SlideOver open={open} onClose={onClose} title="Nouveau club invité">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm mb-1">Nom du club *</label>
          <input
            className="w-full rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm dark:text-white"
            value={form.nom_club}
            onChange={(e) =>
              setForm((s) => ({ ...s, nom_club: e.target.value }))
            }
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Email</label>
          <input
            type="email"
            className="w-full rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm dark:text-white"
            value={form.mail_club}
            onChange={(e) =>
              setForm((s) => ({ ...s, mail_club: e.target.value }))
            }
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Téléphone</label>
          <input
            className="w-full rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm dark:text-white"
            value={form.tel_club}
            onChange={(e) =>
              setForm((s) => ({ ...s, tel_club: e.target.value }))
            }
          />
        </div>

        <div className="pt-2 flex items-center justify-end gap-2">
          <Button
            variant="outline"
            icon={FaTimes}
            onClick={onClose}
            className="rounded-lg"
          >
            Annuler
          </Button>
          <Button type="submit" icon={FaSave} className="rounded-lg">
            Créer
          </Button>
        </div>
      </form>
    </SlideOver>
  );
};

export default CreateInvitedClubModal;
